"use client";

import { createAuthClient } from "better-auth/react";
import { adminClient, phoneNumberClient, emailOTPClient } from "better-auth/client/plugins";

export const authClient = createAuthClient({
  baseURL: "",
  basePath: "/api/auth",
  plugins: [adminClient(), phoneNumberClient(), emailOTPClient()],
});

export const { signIn, signUp, signOut, useSession, getSession } = authClient;
export const emailOtp = authClient.emailOtp;

export async function forgetPassword(options: { email: string }) {
  return authClient.emailOtp.sendVerificationOtp({
    email: options.email,
    type: "forget-password",
  });
}

export async function resetPassword(options: { email: string; otp: string; password: string }) {
  return authClient.emailOtp.resetPassword({
    email: options.email,
    otp: options.otp,
    password: options.password,
  });
}
